import {MutationPayload} from 'vuex';
import {RootState} from '@/store/types';
import {MutationTypes as SEOMutationTypes} from '@/modules/seo/store/mutations'
import store from '@/store'

/**
 * Establece la información SEO actualmente en edición
 *
 * @param {MutationPayload} mutation
 * @param {RootState} state
 */
const setCurrentMetadata = (mutation: MutationPayload, state: RootState) => {
    store.commit(`seo/${SEOMutationTypes.SetCurrentMetadata}`, mutation.payload['seo'])
}

/**
 * Establece la traducción actualmente en edición
 *
 * @param {MutationPayload} mutation
 * @param {RootState} state
 */
const setCurrentTranslation = (mutation: MutationPayload) => {
    store.commit('seo/metadata/current/translation/set', mutation.payload)
}

export { setCurrentMetadata, setCurrentTranslation }
